import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/java-blue.svg'


const _hoisted_1 = {
  id: "modal-java",
  class: "modal modal-md fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-3" }
const _hoisted_5 = { class: "java-info-card row" }
const _hoisted_6 = { class: "col-10 text-start" }
const _hoisted_7 = {
  href: "https://www.java.com/pt-BR/download/",
  target: "_blank",
  class: "fs-6 mb-0 link"
}
const _hoisted_8 = { class: "d-flex gap-2 align-items-start" }
const _hoisted_9 = {
  href: "https://emissao-online-hom.soluti.com.br/ManualEmissaoA1.pdf",
  target: "_blank",
  class: "btn btn-sm btn-outline-primary mt-3"
}
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = ["href"]

import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import sendClarityEvent from '@/utils/sendClarityEvent'

  import { ref, onMounted } from 'vue'
  import { useAR } from '@/store/Pinia/useAR.store'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalJava',
  setup(__props, { expose: __expose }) {

  const { getLinkEmissor } = useAR()

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  onMounted(() => {
    modal.value = new Modal('#modal-java', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function sendEvent() {
    sendClarityEvent('downloadJavaIssuer')
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "modal-header pb-3" }, [
          _createElementVNode("button", {
            class: "btn-close",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "modal-title mb-4" }, " Veja como instalar o Certificado Digital em seu computador ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-2" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "java"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "fs-6 mb-0" }, " Antes de fazer o download do emissor, você precisa ter o Java instalado e atualizado em seu computador. ", -1)),
              _createElementVNode("a", _hoisted_7, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "me-2" }, "Clique aqui para fazer o download", -1)),
                _createVNode(IconComponent, {
                  class: "mt-2",
                  name: "download"
                })
              ])
            ])
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "fs-6 fw-bold text-start mt-4" }, " Após o download, siga os passos até a conclusão da instalação. ", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(IconComponent, {
              class: "green pt-1",
              name: "circle-check"
            }),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-start" }, [
              _createElementVNode("p", { class: "fs-6" }, [
                _createTextVNode(" Tenha em mãos seu "),
                _createElementVNode("strong", null, "usuário*"),
                _createTextVNode(" e a "),
                _createElementVNode("strong", null, "senha de emissão"),
                _createTextVNode(" do seu Certificado Digital. ")
              ]),
              _createElementVNode("p", { class: "fs-6 mt-2" }, " *Você pode encontrar seu código de usuário em seu e-mail com o texto: “Emissão de Certificado Digital APROVADA” no assunto. ")
            ], -1))
          ]),
          _createElementVNode("a", _hoisted_9, [
            _createVNode(IconComponent, {
              class: "me-2",
              name: "up-right-from-square"
            }),
            _cache[4] || (_cache[4] = _createTextVNode(" Guia de instalação do Java "))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", {
            href: _unref(getLinkEmissor),
            target: "_blank",
            class: "btn btn-primary",
            onClick: sendEvent
          }, [
            _createVNode(IconComponent, {
              class: "me-2",
              name: "download"
            }),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Baixar emissor", -1))
          ], 8, _hoisted_11)
        ])
      ])
    ])
  ]))
}
}

})